import { SearchService, SessionStorageUtils, PreSearchUtils } from 'of-components';

export default (data) => {
    const oldFormat = SearchService.toOldFormat(data);
    const searchURL = SearchService.getSearchURL(data, Odigeo.AB.isStreamSearch);
    SessionStorageUtils.setJSON('searchParameters', oldFormat);

    // MFS-1250
    !data.isHotel && Odigeo.AB.isImmediateSearchActive && PreSearchUtils.preSearch(oldFormat, searchURL.split('#')[1]);

    window.location.href = searchURL;
};
